import { gql, useMutation } from '@apollo/client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon } from 'react-bulma-components';
import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';
import { faBookmark as faBookmarkSolid } from '@fortawesome/free-solid-svg-icons';
import { getRoles } from '../auth/roles';
import { useAuth } from 'react-oidc-context';

const ADD_BOOKMARK = gql`
  mutation AddBookmark($songSlug: String!, $type: String!) {
    addBookmark(songSlug: $songSlug, type: $type) {
      slug
      isBookmarked
    }
  }
`;

const REMOVE_BOOKMARK = gql`
  mutation RemoveBookmark($songSlug: String!) {
    removeBookmark(songSlug: $songSlug) {
      slug
      isBookmarked
    }
  }
`;

const BookmarkButton = ({ slug, type, isBookmarked }) => {
  const auth = useAuth();
  const [addBookmark] = useMutation(ADD_BOOKMARK);
  const [removeBookmark] = useMutation(REMOVE_BOOKMARK);

  if (!auth.isAuthenticated) return null;

  const canBookmark = getRoles(auth.user).includes('subscriber');

  const toggle = () => {
    if (!canBookmark) return;
    if (isBookmarked) {
      removeBookmark({ variables: { songSlug: slug } });
    } else {
      addBookmark({ variables: { songSlug: slug, type } });
    }
  };

  return (
    <Tippy
      content={!canBookmark ? 'Subscribers only' : (isBookmarked ? 'Remove bookmark' : 'Bookmark this')}
      delay={0}
      animation={false}
      theme="bookmark"
    >
      <span
        onClick={toggle}
        style={{ cursor: canBookmark ? 'pointer' : 'not-allowed', opacity: canBookmark ? 1 : 0.4 }}
      >
        <Icon size="medium">
          <FontAwesomeIcon icon={isBookmarked ? faBookmarkSolid : faBookmarkRegular} color="white" size="lg" />
        </Icon>
      </span>
    </Tippy>
  );
};

export default BookmarkButton;
